( function( global, $ ) {

    $('[data-href]').click(function(event) {
        event.preventDefault();
        if ($(this).find('a').attr('target') == '_blank') {
            window.open($(this).attr('data-href'), '_blank');
        } else {
            window.location.href = $(this).attr('data-href');
        }
    });

    $('[data-find-us]').click(function(event) {

        if (event.target.parentNode.nodeName != "A" && this.nodeName != "A") {
            event.preventDefault();

            if ($(this).find('a').attr('target') == '"_blank"') {
                window.open($(this).attr('data-find-us'), '_blank');
            } else {
                window.location.href = $(this).attr('data-find-us');
            }
        }
    });


}( window.groots, jQuery ));
